<template>
  <base-section
    id="sponsors"
  >
    <v-container>
    <base-section-heading
    title="Financial Sponsors"
    align="left"
    :toColor="true"
    >
      </base-section-heading>
    <v-row>
      <template v-for="(sponsor, i) in sponsors">
        <v-col
        :key="i"
        cols="12"
        md="3"
        sm="12"
        class="align-self-center"
        >
        <a
          :href="sponsor.to"
          target="_blank"
        >
          <base-img
          v-bind="sponsor"
          color="grey"
          contain
          height="50"
          width="164"
          />
        </a>
        </v-col>
      </template>
    </v-row>
    <br><br><br><br><br>
    <base-section-heading
    title="Technical Sponsors"
    align="left"
    :toColor="true"
    >
      </base-section-heading>
    <v-row>
      <template v-for="(sponsor, i) in technical">
        <v-col
        :key="i"
        cols="12"
        md="3"
        sm="12"
        class="align-self-center"
        >
        <a
          :href="sponsor.to"
          target="_blank"
        >
          <base-img
          v-bind="sponsor"
          color="grey"
          contain
          height="50"
          width="164"
          />
        </a>
        </v-col>
      </template>
    </v-row>
    <br><br><br><br><br>
    <base-section-heading
    title="Main Organizing Institution"
    align="left"
    :toColor="true"
    >
      </base-section-heading>
    <v-row>
      <template v-for="(sponsor, i) in organizing">
        <v-col
        :key="i"
        cols="12"
        md="3"
        sm="12"
        class="align-self-center"
        >
        <a
          :href="sponsor.to"
          target="_blank"
        >
          <base-img
          v-bind="sponsor"
          color="grey"
          contain
          height="100"
          width="164"
          />
        </a>
        </v-col>
      </template>
    </v-row>
    <br><br><br><br><br>
    <base-section-heading
    title="Co-organizing Institutions"
    align="left"
    :toColor="true"
    >
      </base-section-heading>
    <v-row>
      <template v-for="(sponsor, i) in coorganizing">
        <v-col
        :key="i"
        cols="12"
        md="3"
        sm="12"
        class="align-self-center"
        >
        <a
          :href="sponsor.to"
          target="_blank"
        >
        <base-img
          v-bind="sponsor"
          color="grey"
          contain
          height="100"
          width="164"
          />
          </a>
        </v-col>
      </template>
    </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Sponsors',

    data: () => ({
        sponsors: [
          /*
            {
            src: require('@/assets/logo-1-light.png'),
            to: 'https://www.ieee.org',
            },
          */
            {
            src: require('@/assets/logo-2-light.png'),
            to: 'https://ieee-ceda.org',
            },
        ],
        technical: [
          /*
            {
            src: require('@/assets/computersociety.png'),
            to: 'https://www.computer.org/',
            },
            */
            {
            src: require('@/assets/logo-5-light.png'),
            to: 'https://www.ieee-tttc.org',
            },
        ],
        organizing: [
            {
              src: require('@/assets/polito.png'),
              to: 'https://www.polito.it',
            },
        ],
        coorganizing: [
            {
              src: require('@/assets/universidadcolombiapedagogica.png'),
              to: 'https://www.uptc.edu.co/sitio/portal/',
            },
            {
              src: require('@/assets/universidadcolombia.png'),
              to: 'https://unal.edu.co/',
            },
        ],
    }),
  }
</script>
